<template>
	<div class="survey">
		<div class="survey-container">
			<div class="mb-5" style="text-align: right;">
        <img
          width="119"
          :src="$apiUrl + '/storage/CLQ4NvrdRsUlnUhiUZxpVHAqzwXbVqDvpL2uvjv8.jpg'"
          alt=""
        />
			</div>

			<h2>Tack för ditt svar!</h2>

			<div class="mt-5">
				<p>Du är en viktig del i att skapa ännu bättre förutsättningar för smart vardagsresande åt dig och oss alla.</p>

				<p>Som anställd på Region Gotland och Gotlandshem har du även möjlighet att bidra med data genom appen <a href="https://www.commutesaver.net/applicationguide" target="_blank">CommuteSaver</a>. Appen känner helt automatiskt av vilken färdmedelstyp som används mellan hem och kontor (inget annat!), vilket möjliggör att vi kan mäta effekten av de insatser vi gör under perioden. All data som samlas in kommer endast vara i aggregerad form och arbetsgivaren kan inte se någon enskild medarbetares resande. Du behöver inte delta men vi vore väldigt tacksamma.</p>
				<p>Ange koden <strong>regiongotland</strong> om du arbetar på Region Gotland och <strong>gotlandshem</strong> om du arbetar på Gotlandshem i fältet för "Workplace Code" i appen.</p>
				<p>Ladda ner appen på <a href="https://play.google.com/store/apps/details?id=com.commutesaver" target="_blank">Google Play</a> för Android och <a href="https://apps.apple.com/se/app/commutesaver/id1587747587" target="_blank">Appstore</a> för iPhone.</p>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
	name: 'Vue',

	data() {
		return {
			clientRegister: null
		}
	},

	created() {

	}
}
</script>
